import { Image as ChakraImage, ImageProps as ChakraImageProps } from '@chakra-ui/react';
import React from 'react';
const assetPath = `/assets`;

export const ImageMap = {
  'balance-background': `${assetPath}/gfx/balance-background.png`,
  'blue-residential-home-3qtr-angle': `${assetPath}/gfx/blue-residential-home-3qtr-angle.png`,
  'call-center-icon': `${assetPath}/gfx/call-center-icon.svg`,
  'cash-flow-icon': `${assetPath}/gfx/cash-flow-icon.svg`,
  celebration: `${assetPath}/gfx/completion-checkmark.png`,
  'coin-up': `${assetPath}/gfx/coin-up.svg`,
  'configure-investor-animation': `${assetPath}/gfx/configure-investor-animation.png`,
  'construction-icon': `${assetPath}/gfx/construction-icon.svg`,
  'contract-icon': `${assetPath}/gfx/contract-icon.svg`,
  'dashboard-header': `${assetPath}/gfx/dashboard-header.gif`,
  'deal-icon': `${assetPath}/gfx/deal-icon.svg`,
  'empty-dividend-bar': `${assetPath}/gfx/empty-dividend-bar.svg`,
  'faded-business': `${assetPath}/gfx/faded-business.png`,
  'faded-house': `${assetPath}/gfx/faded-house.png`,
  'house-search-icon': `${assetPath}/gfx/house-search-icon.svg`,
  keyhole: `${assetPath}/gfx/keyhole.svg`,
  'line-graph': `${assetPath}/gfx/line-graph.svg`,
  logo: `${assetPath}/gfx/logo.svg`,
  'logo-beta': `${assetPath}/gfx/logo-beta.svg`,
  'logo-black': `${assetPath}/gfx/logo-black.svg`,
  'logo-mark-black': `${assetPath}/gfx/logo-mark-black.svg`,
  'logo-mark-blue': `${assetPath}/gfx/logo-mark-blue.svg`,
  'logo-white': `${assetPath}/gfx/logo-white.svg`,
  'residental-home': `${assetPath}/gfx/residental-home.png`,
  'sfr-icon': `${assetPath}/gfx/sfr-icon.svg`,
  'sfr-property-cards': `${assetPath}/gfx/sfr-property-cards.png`,
  'sold-sign-icon': `${assetPath}/gfx/sold-sign-icon.svg`,
  'start-your-profile': `${assetPath}/gfx/start-your-profile.png`,
  'store-badge-android': `${assetPath}/gfx/store-badge-android.png`,
  'store-badge-ios': `${assetPath}/gfx/store-badge-ios.png`,
  'store-qr-code': `${assetPath}/gfx/store-qr-code.svg`,
  'verify-identity': `${assetPath}/gfx/verify-identity.png`,
  'wealth-builder': `${assetPath}/gfx/wealth-builder.svg`,
};

export const Image: React.FC<
  {
    image: keyof typeof ImageMap;
  } & ChakraImageProps
> = ({ image, ...chakraImageProps }) => <ChakraImage src={ImageMap[image]} {...chakraImageProps} />;
